import { UserWorkspaceProfile } from 'models/UserWorkspaceProfile';
import { IGetUserProfileRequest } from 'api/models/request/IGetUserProfileRequest';
import { getProfile } from 'api/services/user-service';
import useWorkspaceApiCall from 'hooks/useWorkspaceApiCall';
import { useCallback } from 'react';

export const useGetProfile = () => {
    const { callAPI, loading } = useWorkspaceApiCall<IGetUserProfileRequest, UserWorkspaceProfile>(getProfile);

    const getProfileMethod = useCallback(async (userId: string) => {
        return await callAPI({ userId });
    }, [callAPI]);

    return { getProfile: getProfileMethod, getProfilePending: loading };
};